export const defaultStartChatErrorPaneSubtitleStyleProps = {
  fontFamily: "'Segoe UI',Arial,sans-serif",
  fontWeight: "normal",
  fontSize: "18px",
  color: "#36454F",
  textAlign: "center",
  display: "flex",
  order: 3,
  alignSelf: "auto"
};